import React from 'react';
import { useTranslation } from 'react-i18next';
import { EVENTS, trackEvent } from '@app/segment';
import { BrowseSwitcherLink } from '@app/router';
import { TooltipIcon, ArrowRightIcon } from '@stockx/icons';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  usePopover,
  Text,
  Heading,
  Flex,
  VisuallyHidden,
  Button,
} from '@stockx/ui';

interface TileCollectionHeaderProps {
  swooshName?: string;
  vertical?: string;
  children: React.ReactNode;
  viewMoreUrl?: string;
  popoverText?: string;
  rel?: string;
}

const TileCollectionHeader: React.FC<TileCollectionHeaderProps> = ({
  swooshName,
  vertical,
  children,
  viewMoreUrl,
  popoverText,
  rel,
  ...props
}) => {
  const { t } = useTranslation();
  const { sx } = usePopover();
  return (
    <Flex mt="6" mb="4" justify="space-between" align="center" {...props}>
      <Heading size="lg" variant="medium">
        {children}
        {popoverText && (
          <Popover trigger={'hover'} placement="top">
            <PopoverTrigger>
              <TooltipIcon
                marginLeft="1"
                boxSize="5"
                verticalAlign="-0.125em"
                aria-hidden="true"
              />
            </PopoverTrigger>
            <PopoverContent sx={sx.popoverContent}>
              <PopoverArrow />
              <PopoverBody>
                <Text fontSize="md">{popoverText}</Text>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        )}
      </Heading>
      {viewMoreUrl && (
        <BrowseSwitcherLink
          to={viewMoreUrl}
          onClick={() => {
            trackEvent(EVENTS.SEE_ALL, {
              vertical,
              swooshName,
              screenName: 'Home',
            });
          }}
          rel={rel}
        >
          <Button
            variant="link"
            color="green.700"
            rightIcon={<ArrowRightIcon />}
          >
            {t('See All')}
          </Button>
          <VisuallyHidden>{children}</VisuallyHidden>
        </BrowseSwitcherLink>
      )}
    </Flex>
  );
};

export default TileCollectionHeader;
